module.exports = __webpack_public_path__ + "img/google.58be3be7.svg";